import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import singleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/singleChoice.vue';
import tableControl from '@/views/questionnaire/customerManage/questionnaireList/components/tableControl.vue';
import multipleChoice from '@/views/questionnaire/customerManage/questionnaireList/components/multipleChoice.vue';
import dateControl from '@/views/questionnaire/customerManage/questionnaireList/components/dateControl.vue';
import dropDownSelect from '@/views/questionnaire/customerManage/questionnaireList/components/dropDownSelect.vue';
import signModel from '@/views/questionnaire/customerManage/questionnaireList/components/signModel.vue'; //签名组件
import paragraphModel from '@/views/questionnaire/customerManage/questionnaireList/components/paragraphModel.vue'; //段落
import enclosureModel from '@/views/questionnaire/customerManage/questionnaireList/components/enclosureModel.vue'; //附件
import { countriesDATA, planArea, logisticsData, bankData } from '@/views/examine/auditManage/request';
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import topTitle from '@/components/title';
import { mapState } from 'vuex';
import moment from 'moment';
import { checkEmail } from '@/utils/validate';
import formItemMixin from '@/mixins/formItemMixin';
export default {
  props: {
    editableArea: {
      type: Array,
      default() {
        return [];
      }
    },
    echoNodeIsEdit: {
      type: Boolean,
      default: false //false不可以编辑true可编辑
    }
  },
  mixins: [formItemMixin],
  components: {
    singleChoice,
    tableControl,
    multipleChoice,
    // emailSendModel,
    dateControl,
    dropDownSelect,
    signModel,
    paragraphModel,
    enclosureModel,
    topTitle,
    singleLineMultilineModel
  },
  computed: {
    ...mapState({
      countriesData: state => state.quiretionnaire.countriesData,
      provinceFirstLevel: state => state.quiretionnaire.provinceFirstLevel,
      provinceData: state => state.quiretionnaire.provinceData,
      provinceArea: state => state.quiretionnaire.provinceArea,
      logisticsData: state => state.quiretionnaire.logisticsData,
      bankData: state => state.quiretionnaire.bankData
    })
  },
  created() {
    this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(item2 => {
      item2.form.forEach(control => {
        var _controlItem$associat;
        console.log(control.control.mark, '----');
        if (control.controlType === 'control') {
          var _control$control;
          control.control.mark = (_control$control = control.control) === null || _control$control === void 0 ? void 0 : _control$control.mark.replace('d.', 'd_');
          if (control.control.partsType === 'multipleChoice') {
            let value = control.control.value || [];
            this.$set(this.formData, control.control.mark, value);
            // control.control.numberLimit = '2,3';
          } else {
            this.$set(this.formData, control.control.mark, control.control.value || undefined);
          }
        } else {
          control.mark = control.mark.replace('d.', 'd_');
          let groupControl = control.control;
          groupControl.forEach(item => {
            item.mark = item.mark.replace('d.', 'd_');
            if (item.partsType === 'multipleChoice') {
              let value = item.value || [];
              this.$set(this.formData, item.mark, value);
            } else {
              this.$set(this.formData, item.mark, item.value || undefined);
            }
          });
        }
        //设置控件显隐 以及处理关联关系
        let mark = control.controlType === 'control' ? control.control.mark : control.mark;
        let controlItem = control.controlType === 'control' ? control.control : control;
        if ((controlItem === null || controlItem === void 0 || (_controlItem$associat = controlItem.association) === null || _controlItem$associat === void 0 || (_controlItem$associat = _controlItem$associat.association) === null || _controlItem$associat === void 0 ? void 0 : _controlItem$associat.length) > 0) {
          let key = controlItem.association.association[0].hideControl.replace('d.', 'd_');
          let value = controlItem.association.association[0];
          value.targetKey = mark;
          if (Array.isArray(this.associationInfo[key])) {
            this.associationInfo[key].push(value);
          } else {
            this.associationInfo[key] = [value];
          }
          this.$set(this.showControl, mark, false);
        } else {
          this.$set(this.showControl, mark, true);
        }
      });
    });
    this.formatRules();
  },
  data() {
    return {
      formData: {},
      showControl: {},
      rules: {},
      associationInfo: {},
      vidateStatus: true,
      submitData: []
    };
  },
  methods: {
    // validateEmail(rules, value, callback) {
    //   if (value && !checkEmail(value)) {
    //     callback(new Error(this.$t('邮箱格式有误，请重新填写')));
    //   }
    //   callback();
    // },
    // generateValidateRule(control) {
    //   const rules = [];
    //   if (control.attributeVerification === 'PHONE') {
    //     rules.push({
    //       pattern: /^1[0-9]{10}$/,
    //       message: this.$t('请输入有效的手机号码'),
    //       trigger: 'blur'
    //     });
    //   }

    //   if (control.attributeVerification === 'IDCODE') {
    //     rules.push({
    //       pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    //       message: this.$t('请输入有效的身份证号码'),
    //       trigger: 'blur'
    //     });
    //   }
    //   const validateEnclosure = (rule, value, callback) => {
    //     let files = this.formData[control.mark];
    //     if (!files || files.length === 0) {
    //       callback(new Error(this.$t('请上传附件')));
    //     } else {
    //       callback();
    //     }
    //   };
    //   if (control.attributeVerification === 'email') {
    //     rules.push({
    //       validator: this.validateEmail,
    //       message: this.$t('请输入有效的邮箱地址'),
    //       trigger: 'blur'
    //     });
    //   }
    //   if (control.attributeVerification === 'NUMBER') {
    //     rules.push({
    //       pattern: /^\d+(\.\d+)?$/,
    //       message: this.$t('请输入数字'),
    //       trigger: 'blur'
    //     });
    //     // 校验小数点
    //     let decimalPlaces = this.formData[control.mark]?.split('.')[1];
    //     let len = String(decimalPlaces)?.split('').length;
    //     if (len > control.decimalPlaces) {
    //       let msg = this.$t('最多只能输入带有0位小数的数值').replace('0', control.decimalPlaces);
    //       rules.push({
    //         min: parseInt(0),
    //         max: parseInt(control.decimalPlaces),
    //         message: msg,
    //         trigger: 'blur'
    //       });
    //     }
    //   }
    //   const validateEmptySingleRequired = (rule, value, callback) => {
    //     let controlValue = this.formData[control.mark];
    //     let status = true;
    //     control.controlValue.forEach((item, index) => {
    //       if (!item.emptyValue && item.isWrite && controlValue && item.name === controlValue) {
    //         status = false;
    //       }
    //     });
    //     if (!status) {
    //       callback(new Error(`${this.$t('请选择')}${control.controlName}`));
    //     } else {
    //       callback();
    //     }
    //   };
    //   const validateEmptyMultiplyRequired = (rule, value, callback) => {
    //     let controlValue = this.formData[control.mark];
    //     let status = true;
    //     control.controlValue.forEach((item, index) => {
    //       if (!item.emptyValue && item.isWrite && controlValue && controlValue.indexOf(item.name) !== -1) {
    //         status = false;
    //       }
    //     });
    //     if (!status || !controlValue) {
    //       callback(new Error(`${this.$t('请选择')}${control.controlName}`));
    //     } else {
    //       callback();
    //     }
    //   };
    //   if (control.partsType === 'singleChoice') {
    //     rules.push({
    //       validator: validateEmptySingleRequired,
    //       trigger: 'change'
    //     });
    //   } else if (control.partsType === 'multipleChoice') {
    //     rules.push({
    //       validator: validateEmptyMultiplyRequired,
    //       trigger: 'change'
    //     });
    //   }
    //   // 是否必填校验
    //   if (control.isRequired) {
    //     if (
    //       control.partsType === 'singleChoice' ||
    //       control.partsType === 'multipleChoice' ||
    //       control.partsType === 'date'
    //     ) {
    //       rules.push({
    //         required: true,
    //         message: `${this.$t('请选择')}${control.controlName}`,
    //         trigger: 'blur'
    //       });
    //     } else if (control.partsType === 'enclosure') {
    //       rules.push({
    //         required: true,
    //         validator: validateEnclosure,
    //         trigger: 'blur'
    //       });
    //     } else {
    //       rules.push({
    //         required: true,
    //         message: `${this.$t('请输入')}${control.controlName}`,
    //         trigger: 'blur'
    //       });
    //     }
    //   }
    //   const validateMultipleChoice = (rule, value, callback) => {
    //     const [min, max] = control.numberLimit.split(',');
    //     let multipleValue = this.formData[control.mark];

    //     if (multipleValue && multipleValue.length > parseInt(max)) {
    //       let msg = this.$t('最多只能选择0个').replace('0', max);
    //       callback(new Error(this.$t(`${msg}${control.controlName}`)));
    //     } else if (multipleValue && multipleValue.length < parseInt(min)) {
    //       let msg = this.$t('最少也要选择0个').replace('0', min);
    //       callback(new Error(this.$t(`${msg}${control.controlName}`)));
    //     } else {
    //       callback();
    //     }
    //   };

    //   if (control.numberLimit) {
    //     // console.log('-----limit------', control.value.length);
    //     const [min, max] = control.numberLimit.split(',');
    //     if (control.partsType === 'multipleChoice') {
    //       rules.push({
    //         validator: validateMultipleChoice,
    //         trigger: 'blur'
    //       });
    //     } else {
    //       let msg = this.$t('长度在0到1个字符')
    //         .replace('0', min)
    //         .replace('1', max);
    //       rules.push({
    //         min: parseInt(min),
    //         max: parseInt(max),
    //         message: msg,
    //         trigger: 'blur'
    //       });
    //     }
    //   }
    //   if (control.dateType) {
    //   }
    //   return rules;
    // },
    formatDropResourceMap() {
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.id] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      this.countriesDataMap = loop(this.countriesData, {});
      this.provinceFirstLevelObj = loop(this.provinceFirstLevel, {});
      this.provinceDataObj = loop(this.provinceData, {});
      this.provinceAreaObj = loop(this.provinceArea, {});
      this.logisticsDataObj = loop(this.logisticsData, {});
      this.bankDataObj = loop(this.bankData, {});
    },
    formatRules() {
      this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(item2 => {
        item2.form.forEach(item3 => {
          if (item3.controlType === 'control') {
            let rules = this.generateValidateRule(item3.control);
            if (rules.length > 0) {
              this.$set(this.rules, item3.control.mark, rules);
            }
          } else if (item3.controlType === 'controlGroup') {
            item3.control.forEach(item4 => {
              let rules = this.generateValidateRule(item4);
              if (rules.length > 0) {
                this.$set(this.rules, item4.mark, rules);
              }
            });
          }
        });
      });
      console.log(this.rules, 'this.rules');
    },
    async getOptions() {
      let resource = [countriesDATA({}), planArea({
        level: 1,
        type: 'noAll'
      }), planArea({
        level: 2,
        type: 'noAll'
      }), planArea({
        level: 3,
        type: 'noAll'
      }), bankData({
        level: 1
      }), logisticsData({
        level: 1
      })];
      const loop = (data, obj) => {
        data.forEach(item => {
          obj[item.code] = item.name;
          if (item.children) {
            loop(item.children, obj);
          }
        });
        return obj;
      };
      await Promise.all(resource).then(res => {
        this.countriesData = res[0] || [];
        this.countriesDataMap = loop(res[0], {});
        this.provinceFirstLevel = res[1] || [];
        this.provinceFirstLevelObj = loop(res[1], {});
        this.provinceData = res[2] || [];
        this.provinceDataObj = loop(res[2], {});
        this.provinceArea = res[3] || [];
        this.provinceAreaObj = loop(res[3], {});
        this.bankData = res[4] || [];
        this.bankDataObj = loop(res[4], {});
        this.logisticsData = res[5] || [];
        this.logisticsDataObj = loop(res[5], {});
      });
    },
    changeControlShow(value, key) {
      this.$set(this.showControl, key, value);
    },
    handleControlValue(controlItem) {
      //处理控件的value值
      if (controlItem.partsType === 'table' && this.showControl[controlItem.mark]) {
        // controlItem.controlValue = this.$refs[`table${controlItem.mark}`][0].formDataArray;
        // this.$refs[`table${controlItem.mark}`][0].generationData2();
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      } else if (controlItem.partsType === 'dropDown') {
        let value = this.formData[controlItem.mark];
        controlItem.value = this.handleDropDownData(value, controlItem);
        delete controlItem.dataList;
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      } else if (controlItem.partsType === 'date') {
        //日期组件处理格式
        let value = this.formData[controlItem.mark];
        controlItem.value = value ? moment(value).format(controlItem.dateType) : '';
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      } else if (controlItem.partsType === 'date') {
        //日期组件处理格式
        let value = this.formData[controlItem.mark];
        controlItem.value = value ? moment(value).format(controlItem.dateType) : '';
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      } else {
        controlItem.value = this.formData[controlItem.mark] || '';
        controlItem.mark = controlItem.mark.replace('d_', 'd.');
      }
    },
    onSubmit() {
      let tableValidateStatus = this.validateTable();
      if (!tableValidateStatus) {
        this.vidateStatus = false;
        return;
      }
      this.formatDropResourceMap();
      this.$refs.form.validate(valid => {
        this.vidateStatus = valid;
        this.generateTableData();
        this.submitData = JSON.parse(JSON.stringify(this.editableArea));
        if (valid) {
          this.submitData && Array.isArray(this.submitData) && this.submitData.forEach(nodeItem => {
            nodeItem.form.forEach(controlItem => {
              if (controlItem.controlType === 'controlGroup') {
                controlItem.control.forEach(item => {
                  this.handleControlValue(item);
                });
              } else {
                this.handleControlValue(controlItem.control);
              }
            });
          });
          console.log(this.submitData, '---submitData---');
        }
      });
    },
    validateTable() {
      //验证表格数据
      this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          // console.log('---current---', controlItem);
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                this.$refs[`table${item.mark}`][0].validateForm();
              }
            });
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`table${controlItem.control.mark}`][0].validateForm();
          }
        });
      });
      let validateStatus = true;
      let length = this.editableArea && Array.isArray(this.editableArea) ? this.editableArea.length : 0;
      for (let m = 0; m < length; m++) {
        let nodeItem = this.editableArea[m];
        for (let j = 0; j < nodeItem.form.length; j++) {
          let controlItem = nodeItem.form[j];
          if (controlItem.controlType === 'controlGroup') {
            //控件组
            for (let k = 0; k < controlItem.control.length; k++) {
              let item = controlItem.control[k];
              if (item.partsType === 'table' && this.showControl[item.mark]) {
                if (!this.$refs[`table${item.mark}`][0].validateStatus) {
                  validateStatus = false;
                }
                if (!validateStatus) {
                  break;
                }
              }
            }
          } else if (controlItem.control.partsType === 'table' && this.showControl[controlItem.control.mark]) {
            if (!this.$refs[`table${controlItem.control.mark}`][0].validateStatus) {
              validateStatus = false;
            }
          }
          if (!validateStatus) {
            break;
          }
        }
        if (!validateStatus) {
          break;
        }
      }
      return validateStatus;
    },
    generateTableData() {
      this.editableArea && Array.isArray(this.editableArea) && this.editableArea.forEach(nodeItem => {
        nodeItem.form.forEach(controlItem => {
          var _controlItem$control;
          if (controlItem.controlType === 'controlGroup') {
            controlItem.control.forEach(item => {
              if (item.partsType === 'table' && this.showControl[controlItem.mark]) {
                this.$refs[`table${item.mark}`][0].generationData2();
              }
            });
          } else if (((_controlItem$control = controlItem.control) === null || _controlItem$control === void 0 ? void 0 : _controlItem$control.partsType) === 'table' && this.showControl[controlItem.control.mark]) {
            this.$refs[`table${controlItem.control.mark}`][0].generationData2();
          }
        });
      });
    },
    handleDropDownData(value, item) {
      //下拉选择的value格式处理
      if (!value) {
        return {
          textValue: [],
          codeValue: []
        };
      }
      const generaterText = mapObj => {
        let textValue = [];
        value.forEach(valueArr => {
          let text = '';
          if (Array.isArray(valueArr) && valueArr.length > 0) {
            //多选
            valueArr.forEach((value, index) => {
              if (index === valueArr.length - 1) {
                text = text + mapObj[value];
              } else {
                text = text + mapObj[value] + '/';
              }
            });
          } else {
            //单选
            text = mapObj[valueArr];
          }
          textValue.push(text);
        });
        return textValue;
      };
      let textData = [];
      let dataType = item.type.type;
      if (dataType === 'provinceArea') {
        textData = generaterText(this.provinceAreaObj);
      } else if (dataType === 'province') {
        textData = generaterText(this.provinceDataObj);
      } else if (dataType === 'provinceFirstLevel') {
        textData = generaterText(this.provinceFirstLevelObj);
      } else if (dataType === 'country') {
        textData = generaterText(this.countriesDataMap);
      } else if (dataType === 'bank') {
        textData = generaterText(this.bankDataObj);
      } else if (dataType === 'logistics') {
        textData = generaterText(this.logisticsDataObj);
      } else if (dataType === 'custom') {
        const loop = (data, obj) => {
          data.forEach(item => {
            obj[item.id] = item.name;
            if (item.children) {
              loop(item.children, obj);
            }
          });
          return obj;
        };
        let mapObj = loop(item.dataList, {});
        textData = generaterText(mapObj);
      }
      return {
        textValue: textData,
        codeValue: value
      };
    }
  }
};